import { writable, derived } from 'svelte/store';
import api from '../services/api.js';

function createPiesStore() {
  const { subscribe, set, update } = writable({
    pies: [],
    currentPie: null,
    loading: false,
    error: null,
  });

  return {
    subscribe,

    async fetchPies() {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const pies = await api.getPies();
        update(state => ({ ...state, pies, loading: false }));
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
      }
    },

    async fetchPie(pieId) {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const pie = await api.getPie(pieId);
        update(state => ({ ...state, currentPie: pie, loading: false }));
        return pie;
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
        throw error;
      }
    },

    async createPie(pieData) {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const pie = await api.createPie(pieData);
        update(state => ({
          ...state,
          pies: [...state.pies, pie],
          loading: false,
        }));
        return pie;
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
        throw error;
      }
    },

    async updatePie(pieId, pieData) {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const updatedPie = await api.updatePie(pieId, pieData);
        update(state => ({
          ...state,
          pies: state.pies.map(p => p.id === pieId ? updatedPie : p),
          currentPie: state.currentPie?.id === pieId ? updatedPie : state.currentPie,
          loading: false,
        }));
        return updatedPie;
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
        throw error;
      }
    },

    async deletePie(pieId) {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        await api.deletePie(pieId);
        update(state => ({
          ...state,
          pies: state.pies.filter(p => p.id !== pieId),
          currentPie: state.currentPie?.id === pieId ? null : state.currentPie,
          loading: false,
        }));
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
        throw error;
      }
    },

    async investInPie(pieId, amount) {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const result = await api.investInPie(pieId, amount);
        update(state => ({ ...state, loading: false }));
        return result;
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
        throw error;
      }
    },

    async rebalancePie(pieId) {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const result = await api.rebalancePie(pieId);
        update(state => ({ ...state, loading: false }));
        return result;
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
        throw error;
      }
    },

    clearCurrentPie() {
      update(state => ({ ...state, currentPie: null }));
    },

    reset() {
      set({
        pies: [],
        currentPie: null,
        loading: false,
        error: null,
      });
    },
  };
}

export const pies = createPiesStore();

export const piesList = derived(pies, $pies => $pies.pies);

export const currentPie = derived(pies, $pies => $pies.currentPie);

export const piesLoading = derived(pies, $pies => $pies.loading);